<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#FF8640"
  type="square-loader"
  [fullScreen] = "false">
  <p class="text-lynnco-orange font-bold">
    Loading...
  </p>
</ngx-spinner>
<router-outlet />
